/**
 * 計算フィールド 計算エンジン（#3145）の内部エラー。
 * ⚠️ functions/src/utils/calculation と main/src/utils/calculation は同一内容。
 *    片方だけ変更しないこと（変更時は両方へ反映し、共通テストで一致を確認する）。
 */
import { CalculationErrorCode, calculationErrorMessage } from './constants';

/** エンジン内部で投げる計算エラー。評価器・検証器で捕捉して結果オブジェクトに変換する */
export class CalculationFormulaError extends Error {
  readonly code: CalculationErrorCode;

  constructor(code: CalculationErrorCode, detail?: string) {
    const baseMessage = calculationErrorMessage[code];
    super(detail ? `${baseMessage}（${detail}）` : baseMessage);
    this.code = code;
    this.name = 'CalculationFormulaError';
    Object.setPrototypeOf(this, CalculationFormulaError.prototype);
  }
}
